export enum InterviewStatus {
  Suggestion = 'suggestion',
  Forwarded = 'forwarded',
  Confirmed = 'confirmed',
  Conducted = 'conducted',
  PostponedOrRescheduled = 'rescheduled',
  Declined = 'declined',
  CancelledByCandidate = 'candidate_cancelled',
  CancelledByEmployer = 'employer_cancelled',
  CandidateAbsentWithoutExcuse = 'candidate_no_show',
  EmployerVacancyPaused = 'employer_vacancy_paused',
  NoUpdateFromCemOrKam = 'no_update_from_cem_or_kam',
  Placeholder = 'placeholder',
  Duplicate = 'duplicate',
  NotReconfirmed = 'not_reconfirmed',
  Deleted = 'deleted',
  EmployerAbsent = 'employer_absent',
}

export const INTERVIEW_STATUS_I18N: Record<InterviewStatus, string> = {
  [InterviewStatus.CancelledByCandidate]: 'Vom Kandidaten abgesagt',
  [InterviewStatus.CancelledByEmployer]: 'Vom Arbeitgeber abgesagt',
  [InterviewStatus.CandidateAbsentWithoutExcuse]: 'Kandidat nicht erschienen',
  [InterviewStatus.Conducted]: 'Stattgefunden',
  [InterviewStatus.Confirmed]: 'Bestätigt',
  [InterviewStatus.NoUpdateFromCemOrKam]: 'Kein Update von CEM oder KAM',
  [InterviewStatus.PostponedOrRescheduled]: 'Verschoben',
  [InterviewStatus.Suggestion]: 'Vorschlag',
  [InterviewStatus.Placeholder]: 'Platzhalter',
  [InterviewStatus.Declined]: 'Abgelehnt',
  [InterviewStatus.Forwarded]: 'Weitergeleitet',
  [InterviewStatus.EmployerVacancyPaused]: 'Arbeitgeber pausiert Vakanz',
  [InterviewStatus.Duplicate]: 'Doppelt',
  [InterviewStatus.NotReconfirmed]: 'Nicht rückbestätigt',
  [InterviewStatus.Deleted]: 'Gelöscht',
  [InterviewStatus.EmployerAbsent]: 'Arbeitgeber nicht erschienen',
};
